import React from 'react';
import { Section, SectionHeading, Card } from '../ui';

const Icon = ({ path }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 text-brand-light">
    {path}
  </svg>
);

const benefits = [
  {
    title: 'Save time & money',
    desc: 'Skip the studio booking and the $300+ photographer. Get a full set of professional headshots for a fraction of the cost.',
    icon: <Icon path={<><path d="M12 1v22" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></>} />,
  },
  {
    title: 'Dozens of styles & looks',
    desc: 'Choose professional outfits and backgrounds for LinkedIn, your company bio, real estate, healthcare, and more.',
    icon: <Icon path={<><circle cx="13.5" cy="6.5" r="2.5" /><circle cx="17.5" cy="10.5" r="2.5" /><circle cx="8.5" cy="7.5" r="2.5" /><circle cx="6.5" cy="12.5" r="2.5" /><path d="M12 2a10 10 0 1 0 0 20 2.5 2.5 0 0 0 2-4 2.5 2.5 0 0 1 2-4h2a4 4 0 0 0 4-4 10 10 0 0 0-10-8z" /></>} />,
  },
  {
    title: 'Private — and yours',
    desc: 'We never sell your photos and you own every headshot you receive. Uploads and results auto-delete within 30 days.',
    icon: <Icon path={<><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>} />,
  },
  {
    title: 'Ready in about an hour',
    desc: 'Upload, pick your styles, and your AI headshots are delivered to your dashboard — usually within ~1–2 hours.',
    icon: <Icon path={<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>} />,
  },
];

const Benefits = () => (
  <Section className="bg-black">
    <SectionHeading
      eyebrow="Why HeadshotsNow.ai"
      title="Professional headshots without the studio"
      subtitle="Everything you need for a polished professional image — fast, affordable, and private."
    />
    <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {benefits.map((b) => (
        <Card key={b.title}>
          <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand/10 border border-brand/20">
            {b.icon}
          </div>
          <h3 className="text-lg font-semibold text-white">{b.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-white/60">{b.desc}</p>
        </Card>
      ))}
    </div>
  </Section>
);

export default Benefits;
